/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CrudSystemActionType } from './CrudSystemActionType';
import {
    instanceOfCrudSystemActionType,
    CrudSystemActionTypeFromJSON,
    CrudSystemActionTypeFromJSONTyped,
    CrudSystemActionTypeToJSON,
} from './CrudSystemActionType';
import type { ExecutionSystemActionType } from './ExecutionSystemActionType';
import {
    instanceOfExecutionSystemActionType,
    ExecutionSystemActionTypeFromJSON,
    ExecutionSystemActionTypeFromJSONTyped,
    ExecutionSystemActionTypeToJSON,
} from './ExecutionSystemActionType';
import type { PresetSystemActionType } from './PresetSystemActionType';
import {
    instanceOfPresetSystemActionType,
    PresetSystemActionTypeFromJSON,
    PresetSystemActionTypeFromJSONTyped,
    PresetSystemActionTypeToJSON,
} from './PresetSystemActionType';

/**
 * @type SystemActionPoliciesEntityType
 * アクション名
 * @export
 */
export type SystemActionPoliciesEntityType = CrudSystemActionType | ExecutionSystemActionType | PresetSystemActionType;

export function SystemActionPoliciesEntityTypeFromJSON(json: any): SystemActionPoliciesEntityType {
    return SystemActionPoliciesEntityTypeFromJSONTyped(json, false);
}

export function SystemActionPoliciesEntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemActionPoliciesEntityType {
    if (json == null) {
        return json;
    }
    if (instanceOfCrudSystemActionType(json)) {
        return CrudSystemActionTypeFromJSONTyped(json, true);
    }
    if (instanceOfExecutionSystemActionType(json)) {
        return ExecutionSystemActionTypeFromJSONTyped(json, true);
    }
    if (instanceOfPresetSystemActionType(json)) {
        return PresetSystemActionTypeFromJSONTyped(json, true);
    }

    return {} as any;
}

export function SystemActionPoliciesEntityTypeToJSON(json: any): any {
    return SystemActionPoliciesEntityTypeToJSONTyped(json, false);
}

export function SystemActionPoliciesEntityTypeToJSONTyped(value?: SystemActionPoliciesEntityType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfCrudSystemActionType(value)) {
        return CrudSystemActionTypeToJSON(value as CrudSystemActionType);
    }
    if (instanceOfExecutionSystemActionType(value)) {
        return ExecutionSystemActionTypeToJSON(value as ExecutionSystemActionType);
    }
    if (instanceOfPresetSystemActionType(value)) {
        return PresetSystemActionTypeToJSON(value as PresetSystemActionType);
    }

    return {};
}

